import Preloader from '../components/layout/preloader';
import './home.css';
import './../animations.css'
import frame from './../assets/heroframe2.svg'
import hero from './../assets/heroimg.png'
import heropng01 from './../assets/heropng02.png'
import heropng02 from './../assets/heropng01.png'
import heropng03 from './../assets/heropng03.png'
import halo from './../assets/herohalo.png'
import s2img from './../assets/sec2mainImg.png'
import s2img2 from './../assets/s2img2.png'
import s3img from './../assets/s3img.png'
import s3img2 from './../assets/s3img2.png'
import eye from './../assets/eye.png'
import s4img1 from './../assets/s4img02.png'
import s4img2 from './../assets/s4img01.png'
import s4img3 from './../assets/s4img03.png'
import s5img from './../assets/s5img1.png'
import music from './../assets/s5img2.png'
import gamify from './../assets/gamify.png'
import s6img from './../assets/s6img.png'
import s7img from './../assets/falling.png'
import Adaptive from './adaptivity';
import Audio from '../components/common/audio';

const Home = () => {

  return (
    <>
    <Adaptive />
    <main>
      <Audio />
    <Preloader />
    <section id='hero'>
      <div className="container heroCont">
        <img className='heroillus1 float' src={heropng01} alt="" />
        <img className='heroillus2 float' src={heropng02} alt="" />
        <img className='heroillus3 tilt' src={heropng03} alt="" />
        <div className="container">
        <img className='halo scaleIn' src={halo} alt="" />
        <img className='heroimg floatIn' src={hero} alt="" />
        </div>
        <img className='frame' src={frame} alt="" />
        <div className="heroText">
          <h1 className='linear-wipe'>قــــــارئــة</h1>
          <h1 className='linear-wipe2'>الفنجان</h1>
        </div>
      </div>
    </section>
    {/* 2 */}
    <section id='sec2'>
      <div className="container sec2">
        <div className="container s2Text">
        <img className='s2img2 float ' src={s2img2} alt="" />
          <h3 className='blurIn scrollAnimate'>
            جلست والخوف بعينيها تتأمل فنجاني المقلوب
          </h3>
          <h2 className='blurIn scrollAnimate2'>
            "يا ولدي لا تحزن"
          </h2>
        </div>
        <div className="container s2ImgContainer moveIn scrollAnimate">
        <img className='s2img tilt ' src={s2img} alt="" />
        <img className='s2eye float' src={eye} alt="" />
        </div>
      </div>
    </section>
    {/* 3 */}
    <section id='sec3'>
      <div className="container sec2">
        <div className="container s3ImgContainer moveIn scrollAnimate">
        <img className='s3img tilt ' src={s3img} alt="" />
        <img className='s3img2 fadeIn scrollAnimate2 ' src={s3img2} alt="" />
        </div>
        <div className="container s2Text s3Text blurIn scrollAnimate2">
          <h2>
          فالحب عليك هو المكتوب يا ولدي
          </h2>
        </div>
      </div>
    </section>
    {/* 4 */}
    <section id='sec4'>
      <div className="container sec4">
        <div className="container s2Text s4Text">
          <h4 className="moveIn scrollAnimate">
            لكن سماءك ممطرةٌ وطريقك مسدودٌ.. مسدود
          </h4>
          <h2 className="moveIn scrollAnimate2">
           فحبيبة قلبك يا ولدي نائمة في قصر مرصود
          </h2>
        </div>
        <div className="container s4Comp">
          <img className='s4img1 s4move1 scrollAnimate' src={s4img1} alt="" />
          <img className='s4img2 s4move2 scrollAnimate' src={s4img2} alt="" />
          <img className='ophelia moveIn scrollAnimate' src={s4img3} alt="" />
        </div>
      </div>
    </section>
    {/* 5 */}
    <section id='sec5'>
      <div className="container sec2 s5Cont">
        <div className="container">
        <div className="container s5Text">
          <h1 className='fadeIn scrollAnimate2'>
            من يدخل حجرتها
          </h1>
          <h5 className='moveIn scrollAnimate2'>من يطلب يدها</h5>
          <h5 className='moveIn scrollAnimate2'>من يدنو من سور حديقتها</h5>
        </div>
        <img className='gamify' src={gamify} alt="" />
        </div>
        <div className="container s2ImgContainer moveIn scrollAnimate">
        <img className='s2img tilt ' src={s5img} alt="" />
        <img className='s2eye music float' src={music} alt="" />
        </div>
      </div>
    </section>
    {/* 6 */}
      <section id='sec6'>
      <div className="container sec4">
        <div className="container s2Text s4Text">
          <h2 className='moveIn scrollAnimate2'>
          من حاول فك ضفائرها
          </h2>
          <h4 className='moveIn scrollAnimate2'>
          من حاول فك ضفائرها
          </h4>
          <h4 className='moveIn scrollAnimate2'>
          يا ولدي
          </h4>
        </div>
        <div className="container">
          <img className='moveIn scrollAnimate' src={s6img} alt="" />
        </div>
      </div>
    </section>
    {/* 7 */}
    <section id='sec7'>
      <div className="container">
          <div className="container s7imgContainer">
            <img className='moveIn scrollAnimate s7img' src={s7img} alt="" />
          </div>
        <div className="container s2Text s4Text">
          <h1 className='moveIn scrollAnimate2'>
         مفقودٌ مفقودٌ
          </h1>
          <h1 className='moveIn scrollAnimate2'>
          مفقــــــــــــــــــــودٌ
          </h1>
          <h1 className='moveIn scrollAnimate2'>
         يا ولـــــــــــــــــــــدي
          </h1>
          <h2 className='moveIn scrollAnimate2'>
         يا ولـــــــــــــــــــــدي
          </h2>
        </div>
      </div>
    </section>
    </main>
    </>
  );
};

export default Home;